import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { updateField, getField } from "vuex-map-fields";

Vue.use(Vuex);

const initialSubmissionData = {
  submissionId: null,
  email: "",
  sectionOneTokens: 0,
  sectionTwoTokens: 0,
  sectionThreeTokens: 0,
  questionAnswer: false,
  feedback: "",
  prizeDrawCode: "",
};

export default new Vuex.Store({
  state: {
    isTransitioning: false,
    disabledAnimationBackground: false,
    currentScreenIndex: 0,
    navigationDirection: "next",
    resultsData: {},
    screenList: [
      {
        component: "WelcomeView",
        nextTransition: "fade-up",
        prevTransition: "fade-down",
      },
      {
        component: "IntroView",
        nextTransition: "fade-up",
        prevTransition: "fade-down",
      },
      {
        component: "PageOneView",
        nextTransition: "fade-up",
        prevTransition: "fade-right",
      },
      {
        component: "PageTwoView",
        nextTransition: "fade-left",
        prevTransition: "fade-right",
      },
      {
        component: "PageThreeView",
        nextTransition: "fade-left",
        prevTransition: "fade-right",
      },
      {
        component: "PageFourView",
        nextTransition: "fade-left",
        prevTransition: "fade-right",
      },
      {
        component: "SummaryView",
        nextTransition: "fade-left",
        prevTransition: "fade-right",
      },
      {
        component: "FeedbackView",
        nextTransition: "fade-left",
        prevTransition: "fade-right",
      },
      {
        component: "ThankyouView",
        nextTransition: "fade-left",
        prevTransition: "fade-right",
      },
      {
        component: "LiveResultsView",
        nextTransition: "fade-left",
        prevTransition: "fade-right",
      },
    ],
    content: {},
    submissionData: JSON.parse(JSON.stringify(initialSubmissionData)),
  },
  getters: {
    getField,
    getChartDataChartOne: (state) => {
      const { section1Tokens, section2Tokens, section3Tokens } = state.resultsData;
      const { label: sectionOneLabel, sectionColour: sectionOneColour } = state.content.sections.sectionOne;
      const { label: sectionTwoLabel, sectionColour: sectionTwoColour } = state.content.sections.sectionTwo;
      const { label: sectionThreeLabel, sectionColour: sectionThreeColour } = state.content.sections.sectionThree;

      const chartData = {
        labels: [sectionOneLabel, sectionTwoLabel, sectionThreeLabel],
        datasets: [
          {
            data: [section1Tokens, section2Tokens, section3Tokens],
            backgroundColor: [sectionOneColour, sectionTwoColour, sectionThreeColour],
          },
        ],
      };

      const chartOptions = {
        maintainAspectRatio: false,
        borderWidth: 0,
        plugins: {
          datalabels: {
            color: "white",
            formatter: function (value, context) {
              const total = context.dataset.data.reduce(function (a, b) {
                return a + b;
              }, 0);
              const percent = ((value / total) * 100).toFixed(0);

              return context.chart.data.labels[context.dataIndex] + "\n" + percent + "%";
            },
          },
        },
      };

      return {
        chartData,
        chartOptions,
      };
    },
    getChartDataChartTwo: (state) => {
      const { yesAnswers, noAnswers } = state.resultsData;

      const chartData = {
        labels: ["No", "Yes"],
        datasets: [
          {
            data: [noAnswers, yesAnswers],
            backgroundColor: ["#C62A53", "#04B776"],
          },
        ],
      };

      const chartOptions = {
        maintainAspectRatio: false,
        borderWidth: 0,
        plugins: {
          datalabels: {
            color: "white",
            formatter: function (value, context) {
              const total = context.dataset.data.reduce(function (a, b) {
                return a + b;
              }, 0);
              const percent = ((value / total) * 100).toFixed(0);

              return context.chart.data.labels[context.dataIndex] + "\n" + percent + "%";
            },
          },
        },
      };

      return {
        chartData,
        chartOptions,
      };
    },
  },
  mutations: {
    updateField,

    resetTool(state) {
      state.submissionData = JSON.parse(JSON.stringify(initialSubmissionData));
      state.currentScreenIndex = 0;
    },
  },
  actions: {
    async submit({ state }, payload = { nextView: null }) {
      let { nextView } = payload;
      let currentPageURL = window.location.origin + window.location.pathname;

      // check if it's got a slash at the end and if so remove it
      if (currentPageURL.endsWith("/")) {
        currentPageURL = currentPageURL.slice(0, -1);
      }
      let endpoint = currentPageURL + "/submit";

      let postPayload = {
        // Just send the submission data, and let the endpoint handle the rest
        submissionData: state.submissionData,
      };

      return await axios
        .post(endpoint, postPayload)
        .then((res) => {
          console.log(res.data);

          if (state.submissionData.submissionId === null && state.submissionData.prizeDrawCode === "") {
            // store the submission id and prize draw code back into local state
            const { submissionId, prizeDrawCode } = res.data;
            state.submissionData.submissionId = submissionId;
            state.submissionData.prizeDrawCode = prizeDrawCode;
          }

          if (nextView !== null) {
            const nextScreenIndex = state.screenList.findIndex((screen) => screen.component === nextView);
            if (nextScreenIndex !== -1) {
              state.currentScreenIndex = nextScreenIndex;
            } else {
              throw new Error("Next screen not found");
            }
          } else {
            state.navigationDirection = "next";
            state.currentScreenIndex++;
          }
        })
        .catch((error) => {
          throw error;
        });
    },

    async fetchSurveyData({ state }) {
      let currentPageURL = window.location.origin + window.location.pathname;

      // check if it's got a slash at the end and if so remove it
      if (currentPageURL.endsWith("/")) {
        currentPageURL = currentPageURL.slice(0, -1);
      }

      const surveyToolPageID = state.content.id;

      return await axios
        .get(`${currentPageURL}/getResultsData`, {
          params: {
            ID: surveyToolPageID,
          },
        })
        .then((res) => {
          state.resultsData = res.data;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
});
